import React from "react";
import RethinkUTIL from "../../util/rethink-db";
import FireboardUtils from "../../util/fireboard-util";
import constants from "../../globalization";
import FireboardQRComponent from "./components/QRComponent";

export default class CommonUtil {
    static getQRPayValue = (item, isDev) => {
        let baseURL = process.env.REACT_APP_QR_BASE_URL;
        if (item) {
            const type = 6;
            const checkOrderId = item.id;
            const refId = item.referenceId;
            baseURL += `/checkIn/${type}/${checkOrderId}/${refId}/`;
            return baseURL;
        }
        return null;
    };

    static getQRValueToJoinCheck = (item, sensorData, isDev) => {
        let baseURL = process.env.REACT_APP_QR_BASE_URL;
        if (item && sensorData && sensorData.externalId) {
            const { externalId } = sensorData;
            baseURL += `/checkIn/group-order/${item.referenceId}?checkHeaderId=${item.id}&sensorCode=${externalId}&flowType=2`;
            return baseURL;
        }
        return null;
    };

    static renderQR = (
        itemConfig,
        isDev,
        onClose,
        items = null,
        selectedItem = null,
        supportsTipsOnTotalAmount = null,
        showMemberDetailPopup = null,
        currency,
    ) => {
        const qrValue = CommonUtil.getQRPayValue(itemConfig, isDev);
        if (qrValue) {
            return (
                <FireboardQRComponent
                    items={itemConfig.items}
                    qrValue={qrValue}
                    unpaid={itemConfig.unpaidAmount}
                    closePopup={onClose}
                    currency={currency}
                />
            );
        }
        return null;
    };

    static renderQRToJoinCheck = (item, sensorData, isDev, onClose) => {
        const qrValue = CommonUtil.getQRValueToJoinCheck(item, sensorData, isDev);
        if (qrValue) {
            return (
                <FireboardQRComponent
                    qrValue={qrValue}
                    closePopup={onClose}
                    joinCheck={true}
                />
            );
        }
        return null;
    }

    static getChecksBasedOnFilters = (checkList, orderStatusType, isWalkUpIncluded, isCurbsideIncluded) => {
        if (orderStatusType === "" || orderStatusType === "All") {
            return checkList;
        }

        return checkList.filter(
            ({ elapsedTime, orderStatusId, sourceType, unpaidAmount, tickets, orders }) => {
                //filter Complete or Picked Up or See Counter orders
                if (orderStatusId === 5) {
                    if (orderStatusType === CommonUtil.getDoneStatusName(orders)) {
                        return true;
                    }
                    return false;
                }

                //filter Cancelled or Error orders
                if (orderStatusType === CommonUtil.getOrderNameFromOrderId(orderStatusId)) {
                    return true;
                }

                if (orderStatusType === constants.orderInProgress) {
                    const currentOrderStatusType = CommonUtil.getOrderNameFromId(orderStatusId);
                    if (
                        currentOrderStatusType === constants.orderInProgress ||
                        (currentOrderStatusType === constants.orderError && elapsedTime >= 0) ||
                        (currentOrderStatusType === constants.orderPending && sourceType === 0)
                    ) {
                        return true;
                    }
                    return false;
                }

                if (orderStatusType === constants.orderPending) {
                    if (isWalkUpIncluded || isCurbsideIncluded) {
                        return false;
                    }
                    const currentOrderStatusType = CommonUtil.getOrderNameFromId(orderStatusId);
                    if (
                        (sourceType === 0 && currentOrderStatusType === constants.orderPending && unpaidAmount > 0 && tickets && tickets.length > 0) ||
                        (sourceType !== 0 && currentOrderStatusType === constants.orderPending) ||
                        (currentOrderStatusType === constants.orderError && elapsedTime < 0)
                    ) {
                        return true;
                    }
                    return false;
                }

                if (orderStatusType === constants.openOrders) {
                    const currentOrderStatusType = CommonUtil.getOrderNameFromOrderId(orderStatusId);
                    if (
                        currentOrderStatusType !== constants.orderComplete &&
                        currentOrderStatusType !== constants.cancelOrderText
                    ) {
                        return true;
                    }
                    return false;
                }

                return false;
            }
        );
    };

    static getOrderNameFromOrderId = (orderId) => {
        switch (orderId) {
            case 5:
                return constants.orderComplete;
            case 8:
                return constants.cancelOrderText;
            case 9:
                return constants.orderError;
            default:
                return "";
        }
    };

    static getOrderNameFromId = (orderId) => {
        switch (orderId) {
            case 0:
                return constants.orderPending;
            case 1:
                return constants.orderInProgress;
            case 5:
                return constants.orderComplete;
            case 8:
                return constants.cancelOrderText;
            case 9:
                return constants.orderError;
            default:
                return "";
        }
    };

    static getChecksList = (checks, orderType, storeInfo, activeCheckFilter, sensorsMap) => {
        const prepWindow = storeInfo.data.prepWindow;
        let checkList = [];
        if (orderType === "All") {
            checks &&
                checks.forEach((eachCheck) => {
                    checkList.push(eachCheck);
                });
        } else if (activeCheckFilter === "sourceType") {
            checkList = RethinkUTIL.getFireboardChecks(
                checks,
                orderType === constants.kioskMode,
                orderType === constants.curbSideOrder,
                orderType === constants.onlineOrder,
                orderType === constants.walkUpMode,
                orderType === constants.textToPayMode || orderType === constants.orderType_textToPay,
                orderType === constants.orderType_scanToPay,
                orderType === constants.orderType_Table,
                orderType === constants.orderType_Tab,
            );
        } else if (activeCheckFilter === "orderType") {
            checkList = RethinkUTIL.getFireboardChecksBasedOnOrderType(
                checks,
                storeInfo.data.orderTypes,
                orderType
            );
        } else if (activeCheckFilter === 'revenueCenter') {
            checkList = RethinkUTIL.getFireboardChecksBasedOnRevenueType(
                checks,
                storeInfo.data.revenueCenters,
                orderType
            );
        } else if (activeCheckFilter === 'sensorGroup') {
            if (sensorsMap && sensorsMap?.size) {
                try {
                    const sensorGroups = storeInfo?.data?.sensorGroups || [];
                    const sensorGroup = sensorGroups.find(sensorGrp => (sensorGrp.name).toLowerCase().trim() === orderType.toLowerCase().trim());
                    if (sensorGroup)
                        checkList = CommonUtil.getSensorGroupedChecks(checks, sensorsMap, [sensorGroup?.id]);
                } catch (error) {
                    console.error(error);
                }
            }
        }
        const updatedChecksList = [];
        checkList.forEach((check) => {
            if (check.orderStatusId !== 10) {
                const dueTime = CommonUtil.getDueTime(check);
                updatedChecksList.push({
                    ...check,
                    elapsedTime: FireboardUtils.getElapsedTime(check, prepWindow),
                    dueTime: new Date(dueTime).getTime(),
                    dueTimeDisplay: dueTime,
                });
            }
        });
        return updatedChecksList;
    };

    static getDueTime = (check) => {
        return check.pickupDate || check.orderDate || check.openDate;
    };

    static parseCheckFromRedis = (check) => {
        const order = check.orders && check.orders[0];
        let orderObj = {};
        if (order !== null && order !== undefined) {
            orderObj = {
                checkedIn: order.checkedIn,
                checkHeaderReferenceId: check.referenceId,
                checkInDate: order.checkInDate,
                checkInNote: order.checkInNote,
                checkNumber: check.number,
                checkOrderId: order.id,
                checkOrderReferenceId: order.referenceId,
                completedDate: order.completedDate,
                orderDate: order.orderDate,
                orderStatusId: order.orderStatusId,
                phoneNumber: order.phoneNumber,
                pickupDate: order.pickupDate,
                checkHeaderId: check.id,
            };
        } else {
            orderObj = {
                checkedIn: false,
                checkHeaderReferenceId: check.referenceId,
                checkInDate: null,
                checkInNote: null,
                checkNumber: check.number,
                checkOrderId: 0,
                checkOrderReferenceId: null,
                completedDate: null,
                orderDate: check.openDate,
                orderStatusId: 0,
                phoneNumber: null,
                pickupDate: null,
                checkHeaderId: check.id,
            };
        }
        const parsedCheck = {
            ...check,
            items:
                check.items &&
                check.items.map((item) => ({
                    ...item,
                    checkItemId: item.id,
                })),
            ...orderObj,
        };
        return parsedCheck;
    };

    static getOrderTypeFromSourceType = (type) => {
        switch (type) {
            case 5:
                return constants.curbSideOrder;
            case 8:
                return constants.textToPayMode;
            case 1:
                return constants.kioskMode;
            case 9:
                return constants.orderType_scanToPay;
            case 0:
                return constants.orderType_POS;
            case 6:
                return constants.onlineOrder;
            case 7:
                return constants.walkUpMode;
            default:
                return "";
        }
    };

    static getItemCount = (items) => {
        const count = items
            ? items.reduce((total, item) => {
                if (item) {
                    total += item.quantity;
                }
                return total;
            }, 0)
            : 0;
        return count;
    };

    static getPrintServerChecksBasedOnFilters = (checkList, orderStatusType, orderType) => {
        if (orderStatusType === "") {
            return checkList;
        }

        return checkList.filter(
            ({ elapsedTime, orderStatusId, sourceType, unpaidAmount, tickets, orders }) => {
                //filter Complete or Picked Up or See Counter orders
                if (orderStatusId === 5) {
                    if (orderStatusType === CommonUtil.getDoneStatusName(orders)) {
                        return true;
                    }
                    return false;
                }

                //filter Cancelled or Error orders
                if (orderStatusType === CommonUtil.getOrderNameFromOrderId(orderStatusId)) {
                    return true;
                }

                if (orderStatusType === constants.orderInProgress) {
                    const currentOrderStatusType = CommonUtil.getOrderNameFromId(orderStatusId);
                    if (
                        currentOrderStatusType === constants.orderInProgress ||
                        (currentOrderStatusType === constants.orderError && elapsedTime >= 0) ||
                        (currentOrderStatusType === constants.orderPending && sourceType === 0)
                    ) {
                        return true;
                    }
                    return false;
                }

                if (orderStatusType === constants.orderPending) {
                    if (
                        orderType === constants.curbSideOrder ||
                        orderType === constants.walkUpMode
                    ) {
                        return false;
                    }
                    const currentOrderStatusType = CommonUtil.getOrderNameFromId(orderStatusId);
                    if (
                        (sourceType === 0 && currentOrderStatusType === constants.orderPending && unpaidAmount > 0 && tickets && tickets.length > 0) ||
                        (sourceType !== 0 && currentOrderStatusType === constants.orderPending) ||
                        (currentOrderStatusType === constants.orderError && elapsedTime < 0)
                    ) {
                        return true;
                    }
                    return false;
                }

                if (orderStatusType === constants.openOrders) {
                    const currentOrderStatusType = CommonUtil.getOrderNameFromOrderId(orderStatusId);
                    if (
                        currentOrderStatusType !== constants.orderComplete &&
                        currentOrderStatusType !== constants.cancelOrderText
                    ) {
                        return true;
                    }
                    return false;
                }

                return false;
            }
        );
    };

    static getAllSelectedChecks = (checks, storeTypesPersist, storeInfo, sensorsMap) => {
        const {
            activeCheckFilter,
            sourceTypes: activeSourceTypes,
            orderTypes: activeOrderTypes,
            revenueTypes: activeRevenueTypes,
            sensorGroupTypes: activeSensorGroupTypes,
        } = storeTypesPersist?.data || {};
        const { orderTypes, revenueCenters, sensorGroups } = storeInfo?.data || {};

        if ((activeCheckFilter === "sourceType" && activeSourceTypes.length === 0) ||
            (activeCheckFilter === "orderType" && activeOrderTypes.length === 0) ||
            (activeCheckFilter === "revenueCenter" && activeRevenueTypes.length === 0) ||
            (activeCheckFilter === "sensorGroup" && activeSensorGroupTypes?.length === 0)
        ) {
            return checks;
        }

        let checkList = [];
        switch (activeCheckFilter) {
            case "sourceType":
                let isMatched = false;
                checks.forEach(check => {
                    isMatched = false;
                    activeSourceTypes && activeSourceTypes.forEach(sourceTypeName => {
                        if (
                            (sourceTypeName === constants.curbSideOrder && check.sourceType === 5) ||
                            (sourceTypeName === constants.walkUpMode && check.sourceType === 7) ||
                            ((sourceTypeName === constants.textToPayMode || sourceTypeName === "Text to Pay") && check.sourceType === 8) ||
                            (sourceTypeName === constants.orderType_scanToPay && check.sourceType === 9) ||
                            (sourceTypeName === constants.onlineOrder && check.sourceType === 6) ||
                            (sourceTypeName === constants.kioskMode && check.sourceType === 1) ||
                            (sourceTypeName === constants.orderType_Table && check.sourceType === 0 && !check.tab) ||
                            (sourceTypeName === constants.orderType_Tab && check.sourceType === 0 && check.tab) ||
                            (sourceTypeName === constants.callCenter && check.sourceType === 10)
                        ) {
                            isMatched = true;
                        }
                    });
                    if (isMatched)
                        checkList.push(check);
                });
                break;
            case "orderType":
                let orderTypesIds = [];
                orderTypes && orderTypes.forEach(orTypes => {
                    if (Array.isArray(activeOrderTypes) && activeOrderTypes.length && activeOrderTypes.includes(orTypes.name))
                        orderTypesIds.push(orTypes.id);
                });
                checkList = checks && checks.filter(check => orderTypesIds.includes(check.orderTypeId));
                break;
            case "revenueCenter":
                let revenueCentersIds = [];
                revenueCenters && revenueCenters.forEach(revenue => {
                    if (Array.isArray(activeRevenueTypes) && activeRevenueTypes.length && activeRevenueTypes.includes(revenue.name))
                        revenueCentersIds.push(revenue.id);
                });
                checkList = checks && checks.filter(check => revenueCentersIds.includes(check.revenueCenterId));
                break;
            case "sensorGroup":
                if (sensorsMap && sensorsMap?.size) {
                    try {
                        let sensorGroupIds = [];
                        activeSensorGroupTypes.forEach(sensorGrpName => {
                            const sensorGroup = sensorGroups.find(sensorGrp => (sensorGrp.name).toLowerCase().trim() === sensorGrpName.toLowerCase().trim());
                            if (sensorGroup)
                                sensorGroupIds.push(sensorGroup.id);
                        });
                        checkList = CommonUtil.getSensorGroupedChecks(checks, sensorsMap, sensorGroupIds);
                    } catch (error) {
                        console.error(error);
                    }
                }
                break;
            default:
                checkList = checks;
                break;
        }
        return checkList || [];
    }

    static getNotificationTypeId = (key, storeNotifications) => {
        const notificationTypesMap = new Map([
            ["callServer", { "id": 1, "name": "Call Server" }],
            ["surveyPosted", { "id": 2, "name": "Survey Posted" }],
            ["cardPayment", { "id": 3, "name": "Card Payment" }],
            ["cashPayment", { "id": 4, "name": "Cash Payment" }],
            ["orderError", { "id": 5, "name": "Order Error" }],
            ["paymentError", { "id": 6, "name": "Payment Error" }],
            ["guestCheckIn", { "id": 7, "name": "Guest Check In" }],
            ["receiptPrinted", { "id": 8, "name": "Receipt Printed" }],
            ["orderReceived", { "id": 9, "name": "OrderReceived" }],
            ["idCheck", { "id": 14, "name": "ID Check" }],
            ["channelStatusUpdate", { "id": 16, "name": "Channel Status Update" }],
            ["orderPrinted", { "id": 18, "name": "Order Print" }],
            ["mdmPolicyUpdated", { "id": 19, "name": "MDM Policy Updated" }],
            ["deviceNotification", { "id": 20, "name": "Device Notification" }],
            ["itemOrdered", { "id": 21, "name": "Item Ordered" }],
            ["posPostingError", { "id": 22, "name": "POS Posting Error" }],
        ]);
        if (notificationTypesMap.has(key)) {
            const entry = notificationTypesMap.get(key);
            return storeNotifications.find((each) => each.id === entry.id);
        }
        return null;
    };

    static getCountersFromDeviceGroup = fireBoardSettings => {
        let counters = [];
        if (FireboardUtils.isObjectBlank(fireBoardSettings)) return counters;
        const countersMap = new Map([
            ['hideCurbsideCounter', constants.curbSideOrder],
            ['hideWalkUpCounter', constants.walkup],
            ['hideOnlineCounter', constants.onlineOrder],
            ['hideCallInCounter', constants.callIn],
            ['hidePrepTimeDisplay', constants.prepTime],
            ['hideProductionDisplay', constants.production],
            ['hidePreAuthCounter', constants.preAuthLabel],
        ]);
        Object.entries(fireBoardSettings).forEach(([key, value]) => {
            if (value && countersMap.has(key))
                counters.push(countersMap.get(key));
        });
        return counters;
    };

    static getNotificationTypeNameFromDeviceGrp = (notificationTypeFilters, storeNotifications) => {
        const nNames = [];
        if (FireboardUtils.isObjectBlank(notificationTypeFilters)) return nNames;
        Object.entries(notificationTypeFilters).forEach(([key, value]) => {
            const nType = CommonUtil.getNotificationTypeId(key, storeNotifications)
            if (value && nType)
                nNames.push(nType.name);
        });
        return nNames;
    };

    static getActiveFilterSourceFromDeviceGroup = fireBoardSettings => {
        const { enableFilterSourceOneDineChannel, enableFilterSourcePosOrderType, enableFilterSourcePosRevenueCenter, enableFilterSourceSensorGroup } = fireBoardSettings || {};
        if (enableFilterSourceOneDineChannel)
            return 'sourceType';
        else if (enableFilterSourcePosOrderType)
            return 'orderType';
        else if (enableFilterSourcePosRevenueCenter)
            return 'revenueCenter';
        else if (enableFilterSourceSensorGroup)
            return 'sensorGroup';
        return 'sourceType';
    };

    static getODOrderTypes = filtersArray => {
        let orderTypes = [];
        if (FireboardUtils.isObjectBlank(filtersArray)) return orderTypes;
        const orderTypesMap = new Map([
            ['curbside', constants.curbSideOrder],
            ['online', constants.onlineOrder],
            ['walkUp', constants.walkup],
            ['textToPay', constants.orderType_textToPay],
            ['scanToPay', constants.orderType_scanToPay],
            ['callIn', constants.callIn],
            ['kiosk', constants.kioskMode],
            ['table', constants.orderType_Table],
            ['tab', constants.orderType_Tab],
            ['pos', constants.orderType_POS],
            ['callCenter', constants.callCenter]
        ]);
        Object.entries(filtersArray).forEach(([key, value]) => {
            if (value && orderTypesMap.has(key))
                orderTypes.push(orderTypesMap.get(key));
        });
        return orderTypes;
    }

    static getPOSOrderTypes = (typesArray, orderTypes) => {
        let POSOrderTypes = [];
        if (!Array.isArray(typesArray) || !Array.isArray(orderTypes))
            return POSOrderTypes;

        const orderTypesMap = new Map();
        orderTypes.forEach(orderType => orderTypesMap.set(orderType.externalId, orderType.name));

        typesArray.forEach(extId => {
            if (orderTypesMap.has(extId)) {
                POSOrderTypes.push(orderTypesMap.get(extId));
            }
        });

        return POSOrderTypes;
    };

    static getRevenueCenterOrderTypes = (typesArray, revenueCenters) => {
        let revenueCenterOrderTypes = [];
        if (!Array.isArray(typesArray) || !Array.isArray(revenueCenters))
            return revenueCenterOrderTypes;

        const revenueCentersMap = new Map();
        revenueCenters.forEach(revenueCenter => revenueCentersMap.set(revenueCenter.externalId, revenueCenter.name));

        typesArray.forEach(extId => {
            if (revenueCentersMap.has(extId)) {
                revenueCenterOrderTypes.push(revenueCentersMap.get(extId));
            }
        });

        return revenueCenterOrderTypes;
    };

    static getSensorGroupOrderTypes = (typesArray, sensorGroups) => {
        let sensorGroupOrderTypes = [];
        if (!Array.isArray(typesArray) || !Array.isArray(sensorGroups))
            return sensorGroupOrderTypes;

        const sensorGroupMap = new Map();
        sensorGroups.forEach(sensorGrp => sensorGroupMap.set('' + sensorGrp.id, sensorGrp.name));

        typesArray.forEach(sensorGrpId => {
            if (sensorGroupMap.has(sensorGrpId)) {
                sensorGroupOrderTypes.push(sensorGroupMap.get(sensorGrpId));
            }
        });

        return sensorGroupOrderTypes;
    };

    static getSensorGroupedChecks = (checks, sensorsMap, sensorGroupIds) => {
        let filteredSensors = [];
        sensorGroupIds.forEach(sensorGrpId => {
            const sensors = sensorsMap.has(sensorGrpId) ? sensorsMap.get(sensorGrpId) : [];
            filteredSensors = [...filteredSensors, ...sensors];
        });

        //get all the stationId from sensors array
        let stationIdArray = [];
        if (filteredSensors && Array.isArray(filteredSensors) && filteredSensors.length > 0) {
            filteredSensors.forEach(sensor => {
                if (sensor?.stationId) {
                    stationIdArray.push(sensor.stationId);
                }
            });
        }

        let filteredChecks = [];
        if (checks instanceof Map)
            checks = Array.from(checks.values());
        if (Array.isArray(checks) && checks.length > 0) {
            filteredChecks = checks.filter(check => {
                const { orders, stationId } = check;
                // const [order0] = orders || [];
                // const { stationId } = order0 || {};
                if (stationId && stationIdArray.includes(stationId))
                    return true;
                return false;
            });
        }

        return filteredChecks;
    };

    static getDoneStatusName = orders => {
        const [order0] = orders || [];
        const { orderStatusId, pickUpStatus } = order0 || {};
        let statusName = "";
        if (orderStatusId === 5 && pickUpStatus === 0)
            statusName = constants.orderComplete;
        else if (orderStatusId === 5 && pickUpStatus === 3)
            statusName = constants.seeCounter;
        else if (orderStatusId === 5 && pickUpStatus === 5)
            statusName = constants.pickedUp;

        return statusName;
    };

    static getCheckOrderTypeName = (check, filterSourceType, storeInfo) => {
        const { orderTypes: posOrderTypes, revenueCenters } = storeInfo?.data || {};
        let orderTypeName = 'All';
        switch (filterSourceType) {
            case 'sourceType': {
                const typeName = CommonUtil.getOrderTypeNameFromSourceType(check.sourceType, check.tab);
                orderTypeName = typeName ? typeName : 'All';
                break;
            }
            case 'orderType': {
                const posOrderType = posOrderTypes.find(type => type.id === check?.orderTypeId);
                orderTypeName = posOrderType ? posOrderType?.name : 'All';
                break;
            }
            case 'revenueCenter': {
                const revCenter = revenueCenters.find(rvCenter => rvCenter.id === check?.revenueCenterId);
                orderTypeName = revCenter ? revCenter?.name : 'All';
                break;
            }
            default: orderTypeName = 'All';
        }
        return orderTypeName;
    };

    static getOrderTypeNameFromSourceType = (sourceType, isTab) => {
        switch (sourceType) {
            case 5:
                return constants.curbSideOrder;
            case 8:
                return constants.textToPayMode;
            case 1:
                return constants.kioskMode;
            case 9:
                return constants.orderType_scanToPay;
            case 0:
                return isTab ? constants.orderType_Tab : constants.orderType_Table;
            case 6:
                return constants.onlineOrder;
            case 7:
                return constants.walkUpMode;
            case 10:
                return constants.callCenter;
            default:
                return "";
        }
    };

    static filterPrepAndProductionByCurrentTime = (list) => {
        let filteredList = [];
        const date = new Date();
        const currentYear = date.getFullYear();
        const currentMonth = date.getMonth();
        const currentDate = date.getDate();
        if (list && Array.isArray(list) && list.length > 0) {
            list.forEach(row => {
                try {
                    const { startTime, endTime } = row;
                    const [startHours, startMinutes, startSeconds] = startTime.split(':');
                    const [endHours, endMinutes, endSeconds] = endTime.split(':');
                    const startDateInMS = new Date(currentYear, currentMonth, currentDate, +startHours, +startMinutes, +startSeconds, 0).getTime();
                    const endDateInMS = new Date(currentYear, currentMonth, currentDate, +endHours, +endMinutes, +endSeconds, 0).getTime();
                    const currentDateInMS = new Date(currentYear, currentMonth, currentDate, date.getHours(), date.getMinutes(), date.getSeconds(), 0).getTime();
                    if ((startDateInMS > currentDateInMS) || (startDateInMS < currentDateInMS && endDateInMS > currentDateInMS)) {
                        filteredList.push(row);
                    }
                } catch (error) {
                    console.error(`error - ${error}`);
                }
            });
        }
        return filteredList;
    };

    static getCurrentPrepAndProdFromPrepProdSlot = (list) => {
        let prepAndProd = { prepWindow: 0, production: 0 };
        const date = new Date();
        const currentYear = date.getFullYear();
        const currentMonth = date.getMonth();
        const currentDate = date.getDate();
        if (list && Array.isArray(list) && list.length > 0) {
            const prepProdSlot = list.find(row => {
                try {
                    const { startTime, endTime } = row;
                    const [startHours, startMinutes, startSeconds] = startTime.split(':');
                    const [endHours, endMinutes, endSeconds] = endTime.split(':');
                    const startDateInMS = new Date(currentYear, currentMonth, currentDate, +startHours, +startMinutes, +startSeconds, 0).getTime();
                    const endDateInMS = new Date(currentYear, currentMonth, currentDate, +endHours, +endMinutes, +endSeconds, 0).getTime();
                    const currentDateInMS = new Date(currentYear, currentMonth, currentDate, date.getHours(), date.getMinutes(), date.getSeconds(), 0).getTime();
                    return (startDateInMS < currentDateInMS && endDateInMS > currentDateInMS);
                } catch (error) {
                    console.error(`error - ${error}`);
                }
            });
            if (prepProdSlot) {
                const { overridePrepWindow, overrideProduction, prepWindow, production } = prepProdSlot;
                if (overridePrepWindow && overrideProduction) { //if override values are present - return override values
                    prepAndProd = {
                        prepWindow: overridePrepWindow,
                        production: overrideProduction,
                    };
                } else { //if override values are not present - return normal values
                    prepAndProd = {
                        prepWindow: prepWindow,
                        production: production,
                    };
                }
            }
        }
        return prepAndProd;
    };

}